import { render, staticRenderFns } from "./ProductsLook.vue?vue&type=template&id=3661f5f0"
import script from "./ProductsLook.vue?vue&type=script&lang=js"
export * from "./ProductsLook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports